export enum CustomDataTableSortLogic {
  CMMC_REFERENCE_NUMBER = 1,
  CMMC_CONTROL_NUMBER = 2
}
